import React, { FC } from "react";
import { useDecision } from "@optimizely/react-sdk";
import { OptimizelyExperimentation } from "../BookingButton/OptimizelyExperimentation.csharp";

export interface HeroPriceProps {
	priceText: string;
	fontColor: string;
	optimizelyExperimentation: OptimizelyExperimentation;
}
export const HeroPrice: FC<HeroPriceProps> = ({
	priceText,
	fontColor,
	optimizelyExperimentation,
}) => {
	const [decision] = useDecision(
		optimizelyExperimentation.flags.enablePriceInHero
	);
	
	return decision.enabled ? (
		<span className="HeroPrice" style={{ color: fontColor }}>
			{priceText}
		</span>
	) : null;
};
